module.exports = __webpack_public_path__ + "logo.png?293dbd0676d877795cda0b7d495cc1ab";